import { TerminalError } from "@/utils/UTerminal";

import { TTerminalCommand } from "@/types";

import { numberArg } from "../args/number.arg";

export const endCommand: TTerminalCommand = {
	command: "end",
	description: "End a task",
	execute: (_args) => {
		throw new TerminalError("Not implemented");
	},
	args: [
		numberArg(
			{
				name: "taskId",
				description: "The ID of the task to end",
			},
			"invalidTaskId"
		),
		{
			name: "time",
			description: "The time the task ended",
		},
	],
};
